import React from "react";

const TitleCard = ({ children }) => {
    return (
        <div className="px-6 pt-8">
            <h2 className="mb-6 text-xl text-ink sm:text-2xl tracking-tight" style={{ fontFamily: "'Cinzel', serif", fontWeight: 400 }}>
                { children }
            </h2>
        </div>
    );
};

export default TitleCard;